import PageHead from '../PageHead';
import {
    getFirmPageMetaData,
    hasFirmProfileNoIndexNoFollow,
} from '../../data/metaTagsHelper';
import { useRouter } from 'next/router';

const FirmProfileHead = ({ profile, firmOrNetworkType, services, disableBots }) => {

    const router = useRouter()
    return (
        <PageHead
            disableBots={hasFirmProfileNoIndexNoFollow(profile, firmOrNetworkType) || disableBots}
            {...getFirmPageMetaData(profile, services, router, firmOrNetworkType)}
        />
    );
};

export default FirmProfileHead;
